import { render, staticRenderFns } from "./EditStatementModal.vue?vue&type=template&id=834f696a&scoped=true&"
import script from "./EditStatementModal.vue?vue&type=script&lang=ts&"
export * from "./EditStatementModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditStatementModal.vue?vue&type=style&index=0&id=834f696a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834f696a",
  null
  
)

export default component.exports